module.exports = __webpack_public_path__ + "img/logo.6ba8d3d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/nuxt/assets/images/logo.png
// module id = uGdL
// module chunks = 4 12 20